export default class Actions {
    scrollUp() {
        $('.btn-up').click(function(e) {
          e.preventDefault();

          $('html, body').animate({
            scrollTop: 0
          }, 500);
        });
    }

    scrollToAnchor() {
      $(document).on('click', 'a[href^="#"]', function (e) {
        e.preventDefault();
        if ($.attr(this, 'href') != '#') {
          $('html, body').animate({
            scrollTop: $($.attr(this, 'href')).offset().top - 120
          }, 500);
        }
      });
    }

    navToggler() {
      let toggler = document.querySelector('.hamburger');
      toggler.addEventListener('click', () => {
        document.body.classList.toggle('nav-toggled')
      });

      $('.menu-item-has-children span').click(function(e) {
        e.preventDefault();
        $(this).parent().find('.submenu').toggleClass('active');
      });
    }


    video() {
      $('.box-video button').click(function(e) {
        var $box = $(this).parents('.box-video');
        e.preventDefault();

        $box.find('.box-video__poster').hide();
        $box.find('video').trigger('play');
      })
    }

    tabs() {
      $('.tab-list__header').click(function() {
        $(this).parent().toggleClass('active');
      })
    }
  
    init() {
      document.querySelector('.btn-up') ? this.scrollUp() : null;
      document.querySelector('.hamburger') ? this.navToggler() : null;
      document.querySelector('.box-video') ? this.video() : null;
      document.querySelector('.tab-list') ? this.tabs() : null;
      this.scrollToAnchor();
    }
}
